import React from "react";
import { Controller } from "react-hook-form";
import moment from "moment";

const DateRangeFilter = ({ control, errors, startLabel = "Start Date", endLabel = "End Date" }) => {
  const startDateRef = React.useRef(null);
  const endDateRef = React.useRef(null);

  const handleDateChange = (e, field) => {
    const formatted = moment(e.target.value).format("YYYY/MM/DD");
    field.onChange(formatted);
  };

  return (
    <>
      <div className="row-primary">
        <h2>{startLabel}</h2>
        <Controller
          name="start_date"
          control={control}
          render={({ field }) => (
            <div className="input-image basic_bases">
              <input
                ref={startDateRef}
                id="start_date"
                type="date"
                name="start_date"
                {...field}
                value={moment(field.value).format("YYYY-MM-DD")}
                onChange={(e) => handleDateChange(e, field)}
              />
              <img src="/images/celender.png" alt="calendar" className="custom-icon" />
            </div>
          )}
        />
        {errors?.start_date && <p className="error">{errors.start_date.message}</p>}
      </div>

      <div className="row-primary">
        <h2>{endLabel}</h2>
        <Controller
          name="end_date"
          control={control}
          render={({ field }) => (
            <div className="input-image basic_bases">
              <input
                ref={endDateRef}
                type="date"
                name="end_date"
                {...field}
                value={moment(field.value).format("YYYY-MM-DD")}
                onChange={(e) => handleDateChange(e, field)}
              />
              <img src="/images/celender.png" alt="calendar" className="custom-icon" />
            </div>
          )}
        />
        {errors?.end_date && <p className="error">{errors.end_date.message}</p>}
      </div>
    </>
  );
};

export default DateRangeFilter;
